import styled, { keyframes } from 'styled-components';
import { Scroller } from '../components/Scroller';
import { Language } from '../../assets/ts/customTypes';
import { ProcessStepSlide, InfoBoxContent, ProcessStepSpacer, FittingImage, ProcessStepArrow, ProcessPageInfoIcon, ProcessPageScrollerContent } from '../components/ProcessPageUtils';
import { PageTitle } from '../components/PageTitle';
import { Fragment } from 'react';
import { MainContainer } from '../../assets/ts/layout/main';
import { useLanguage } from '../contexts/LanguageContext';

const fadeInAnimation = () => keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

const ProcessPageContainer = styled(MainContainer)`
    display: flex;
    flex-direction: column;
    justify-content: center;

    ${Scroller} {
        opacity: 0;
        animation: ${fadeInAnimation} 1s forwards;
    }
`;

export function ProcessPage(props: {
    page: keyof Language['processPages'];
}) {
    const [language] = useLanguage();
    const page = language.processPages[props.page];

    return <ProcessPageContainer>

        <PageTitle width={page.headlineWidth} animationDelay={1}>
            {page.headline}
        </PageTitle>

        <Scroller resetScrollKey={props.page}>
            <ProcessPageScrollerContent>
            <ProcessStepSlide
                    headline={page.infoBox.headline}
                >
                    {page.infoBox.bullets.map((content, index) => (
                        <InfoBoxContent key={index}>
                            <ProcessPageInfoIcon />
                            {content}
                        </InfoBoxContent>
                    ))}
                </ProcessStepSlide>

                {page.steps.map((step, index) => (
                    <Fragment key={index.toString()}>
                        <ProcessStepSpacer>
                            {index > 0 && <ProcessStepArrow />}
                        </ProcessStepSpacer>

                        <ProcessStepSlide
                            step={index + 1}
                            image={<FittingImage src={step.imageUrl} />}
                            headline={step.headline}
                        >
                            {step.content}
                        </ProcessStepSlide>
                    </Fragment>
                ))}
            </ProcessPageScrollerContent>
        </Scroller>
    </ProcessPageContainer>;
}
